import { render, staticRenderFns } from "./knowledgeBaseRepDetail.vue?vue&type=template&id=54f15712&scoped=true"
import script from "./knowledgeBaseRepDetail.vue?vue&type=script&lang=js"
export * from "./knowledgeBaseRepDetail.vue?vue&type=script&lang=js"
import style0 from "./knowledgeBaseRepDetail.vue?vue&type=style&index=0&id=54f15712&prod&lang=css"
import style1 from "./knowledgeBaseRepDetail.vue?vue&type=style&index=1&id=54f15712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f15712",
  null
  
)

export default component.exports